import * as yup from "yup";

export interface CreateEnterpriseUserProps {
  isOpen: boolean;
  setOpenModalCreate: () => void;
}

export type CreateEnterpriseUserFormData = yup.InferType<typeof createEnterpriseUserSchema> & {
  paymentMethod: string;
  payrollManagedBy?: string;
};

export const createEnterpriseUserSchema = yup.object().shape({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  emailAddress: yup
    .string()
    .email("Invalid email")
    .required("Email is required"),
  // .max(8, 'The length must be between 0 and 8')
  bussinessUnitName: yup
    .string()
    .matches(
      /^[a-zA-Z0-9\s]*$/,
      "Only alphabets, numbers and space are allowed"
    )
    .required("Business Unit Name is required"),
  bussinessUnitCode: yup
    .string()
    .min(2, "Business Unit Code must be at least 2 characters long")
    .max(15, "Business Unit Code must be at less than 12 characters long")
    .matches(
      /^[A-Z0-9]+$/,
      "Only uppercase alphabets and numbers without space are allowed"
    )
    .required("Business Unit Code is required"),
  userRole: yup.string().when("$isPaymentOpsRole", {
    is: false,
    then: (schema) => schema.required("User Role is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  payrollManagedBy: yup.string().when("$isPaymentOpsRole", {
    is: true,
    then: (schema) => schema.required("Payroll Managed By is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  serviceProviderCode: yup
    .string()
    .min(2, "Service Provider Code must be at least 2 characters long")
    .max(15, "Service Provider Code must be at less than 12 characters long")
    .matches(
      /^[A-Z0-9]+$/,
      "Only uppercase alphabets and numbers without space are allowed"
    )
    .required("Service Provider Code is required"),
});
